import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { DataAvailabilityInfo } from '../types/data-availability-info.type';

@Injectable({ providedIn: 'root' })
export class DataAvailabilityService {
  // Keyed by processGroupId; undefined key represents the global (no filter) entry.
  private cache = new Map<string, DataAvailabilityInfo>();

  constructor(private apiService: ApiService) {}

  async getDataAvailability(processGroupId?: string): Promise<DataAvailabilityInfo | null> {
    if (this.cache.has(processGroupId)) {
      return this.cache.get(processGroupId);
    }

    try {
      const datesWithData = await this.apiService.monitoring.getDatesWithData(processGroupId);
      const isValid = Array.isArray(datesWithData) && datesWithData.length > 0;
      const dataAvailabilityInfo = new DataAvailabilityInfo(datesWithData, isValid);
      this.cache.set(processGroupId, dataAvailabilityInfo);
      return dataAvailabilityInfo;
    } catch {
      return null;
    }
  }

  /** Removes all cached entries (e.g. on day rollover when all data must be re-fetched). */
  clear(): void {
    this.cache.clear();
  }

  /** Removes a single cached entry so the next call re-fetches it. Omit id to invalidate the global entry. */
  invalidate(processGroupId?: string): void {
    this.cache.delete(processGroupId);
  }
}
